import { render, staticRenderFns } from "./Layout5.vue?vue&type=template&id=6a2a9c75"
import script from "./Layout5.vue?vue&type=script&lang=js"
export * from "./Layout5.vue?vue&type=script&lang=js"
import style0 from "./Layout5.vue?vue&type=style&index=0&id=6a2a9c75&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports